import React, { useEffect } from 'react';

const FontProvider = ({ children }) => {
    useEffect(() => {
        document.documentElement.style.setProperty('font-family', "'Figtree', sans-serif");
        const style = document.createElement('style');
        style.textContent = `
      * {
        font-family: 'Figtree', sans-serif !important;
      }
    `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return <>{children}</>;
};

export default FontProvider;